import AppMenu from '@modules/sidebar/utils/AppMenu';

let appMenu: AppMenu | undefined;

export default function useAppMenu(): AppMenu {
  if (!appMenu) {
    appMenu = new AppMenu();
  }

  return appMenu;
}
